import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { AlertTriangle, Clock } from 'lucide-react';
import { useSessionTimeout } from '@/hooks/useSessionTimeout';

const SessionTimeoutWarning: React.FC = () => {
  const { timeLeft, showWarning, extendSession, isActive } = useSessionTimeout();

  if (!isActive || !showWarning) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md">
      <Alert variant="destructive" className="border-red-500 bg-red-50">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle className="flex items-center gap-2">
          <Clock className="h-4 w-4" />
          Sesión Expirando
        </AlertTitle>
        <AlertDescription className="mt-2">
          Tu sesión administrativa expirará en <strong>{timeLeft}</strong> por inactividad.
        </AlertDescription>
        <div className="mt-3">
          <Button size="sm" onClick={extendSession} className="w-full">
            Extender Sesión
          </Button>
        </div>
      </Alert>
    </div>
  );
};

export default SessionTimeoutWarning;